import { render, staticRenderFns } from "./FormBasicInputs.vue?vue&type=template&id=ed864cc2"
import script from "./FormBasicInputs.vue?vue&type=script&lang=js"
export * from "./FormBasicInputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports